import { AvailableDistributorId } from 'graphql/generatedModel';

export const getDistributorId = (distributorId: number) => {
  if (distributorId === 1) return AvailableDistributorId.B1;
  if (distributorId === 2) return AvailableDistributorId.B2;
  if (distributorId === 3) return AvailableDistributorId.B3;
  if (distributorId === 4) return AvailableDistributorId.B4;
  return AvailableDistributorId.B1;
};
